import styled, { css } from 'styled-components';
import { Svg } from '../Button/button.styles';

export const Container = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Button = styled.button<{ active?: boolean; disabled?: boolean }>(
  ({ theme: { color, shadows, transition }, active, disabled }) => css`
    border: none;
    padding: 0;
    margin: 0;

    width: 32px;
    height: 32px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${disabled ? 'transparent' : active ? color.ui8 : 'transparent'};
    pointer-events: ${disabled ? 'none' : 'auto'};
    box-shadow: ${disabled ? 'none' : active ? shadows.innerShadow : 'none'};
    fill: ${disabled ? color.ui4 : active ? color.s1 : color.ui2};
    color: ${disabled ? color.ui4 : active ? color.s1 : color.ui2};
    ${transition.default};
    cursor: pointer;

    ${Svg} {
      fill: ${disabled ? color.ui4 : active ? color.s1 : color.ui2};
      color: ${disabled ? color.ui4 : active ? color.s1 : color.ui2};
    }

    &:hover {
      background-color: ${color.ui8};
      fill: ${color.s2};
      color: ${color.s2};
      box-shadow: ${shadows.standByShadow};
    }
  `,
);
